import {Currency, Price} from '@shared/models/price';

export const getCurrencySymbol = (currency: Currency) => {
    switch (currency) {
        case Currency.EUR:
            return '€';
        case Currency.USD:
            return '$';
        case Currency.GBP:
            return '£';
        default : return '€';
    }
};

export const formatAmount = (amount:number) => {
    return (amount / 100).toFixed(2);
};

export const formatPrice = (price: Price, showCurrency = true) => {
    return `${showCurrency ? getCurrencySymbol(price.currency) : ''}${formatAmount(price.amount)}`;
};
